module.exports = __webpack_public_path__ + "img/cover.b683fd22.png";